interface ChannelData {
  channelId: number;
  channelName: string;
  mallCategoryId?: number;
  mallCategoryCode?: string;
  mallCategoryName?: string;
  lastModifiedTime: number;
  priority: number;
  postsCount?: number;
  postIds?: number[];
  disabled: boolean;
  remark: string;
}

interface ResequenceChannelPostsParam {
  channelId: number;
  postOrder: string[];
}

interface ChannelPostDataParam {
  channelId: number;
  postUuid: string[];
}

interface CreateChannelRequest {
  channelName: string;
  disabled: boolean;
  mallCategoryId: string;
  remark: string;
}

export const VIDEO_PLAYER = 'videoPlayer';

type VodTag = 'FLAGSHIP_STORE' | 'REBATE' | 'SPONSOR' | 'REPLAY' | 'LIMITED_TIME';

export type { ChannelData, ChannelPostDataParam, CreateChannelRequest, ResequenceChannelPostsParam, VodTag };
